import { useState } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { Wrapper } from './styles';

type DropzoneProps = {
  id: string;
  name: string;
  form: any;
  dropzoneOptions?: DropzoneOptions;
  filePrompt?: string;
  onLoad?: (form: any, fieldName: string, files: File[], setResult: (files: FileLabelType[]) => void) => Promise<void>;
};

type FileLabelType = {
  name: string;
  description: string;
};

const Dropzone = (props: DropzoneProps) => {
  const [files, setFiles] = useState<FileLabelType[]>([]);

  // tslint:disable-next-line:no-shadowed-variable
  const onDrop = (acceptedFiles: any) => {
    if (acceptedFiles.length > 0) {
      if (props.onLoad) {
        props.onLoad(props.form, props.name, acceptedFiles, (files: FileLabelType[]) => {
          setFiles(files || []);
        });
      } else {
        const {
          form: { setFieldValue },
        } = props;

        const reader = new FileReader();
        reader.readAsDataURL(acceptedFiles[0]);
        reader.onload = () => {
          const fileAsDataURL = reader.result;
          const dataURLParts = (fileAsDataURL && typeof fileAsDataURL === 'string' && fileAsDataURL.split(',')) || [];
          const dataURLFileType = dataURLParts[0] === 'data:text/csv;base64' ? dataURLParts[0] : 'data:text/csv;base64';
          const dataURLContents = dataURLParts[1];

          const newFile = {
            base64: `${dataURLFileType},${dataURLContents}`,
            filename: acceptedFiles[0].name,
          };
          setFieldValue(props.name, newFile);
          setFiles(
            acceptedFiles.map((f: any) => {
              return { name: f.name, description: f.name };
            })
          );
        };
      }
    } else {
      setFiles([]);
    }
  };
  const options = props.dropzoneOptions ? props.dropzoneOptions : { accept: 'csv' };
  if (!options.onDrop) options.onDrop = onDrop;
  const { getRootProps, getInputProps } = useDropzone(options);

  const prompt = props.filePrompt || "Drag 'n' drop some files here, or click to select files";
  const multiple = options.multiple === undefined ? true : options.multiple;
  return (
    <Wrapper className="container">
      <div id={props.id} {...getRootProps({ className: 'dropzone' })}>
        <input id={props.id} name={props.name} {...getInputProps()} />
        <p>{prompt}</p>
        {!multiple && <p>{files.length ? files[0].description : ''}</p>}
      </div>
      {multiple && (
        <aside>
          <ul>
            {files.map(item => (
              <li key={item.name}>{item.description}</li>
            ))}
          </ul>
        </aside>
      )}
    </Wrapper>
  );
};

export default Dropzone;
